export default __webpack_public_path__ + "static/media/GoogleClassroom.0ee80276.svg";